const en = {
	common: require("@locales/en/common.json"),
	header: require("@locales/en/header.json"),
	"standard-pages": require("@locales/en/standard.json"),
};

const de = {
	footer: {},
	header: {},
};

module.exports = {
	en,
	de,
};
